import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';

import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { FlexColumn, FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import { Button } from 'ui-components/components/button';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';
import { GuidService } from 'ui-components/services/guid-service';

import { AdvancedShippingNoticeDrawer } from './components/advanced-shipping-notice-drawer/advanced-shipping-notice-drawer';
import { useModal } from '../../../hooks/use-modal';
import { initialAdvancedShippingNotice } from './constants';
import { useTrackWorkflow, WorkflowSteps } from '../../../tracking/use-workflow-tracking';
import { Workflows } from '../../../tracking/tracking-constants';
import { AdvancedShippingNoticeGrid } from './components/advanced-shipping-notice-grid/grid';
import { Provider as AdvancedShippingNoticeGridProvider } from './components/advanced-shipping-notice-grid/context';

import { messages } from './messages';
import styles from './advanced-shipping-notice.module.less';

export const AdvancedShippingNotices = () => {
  const { open, close, isOpen } = useModal();
  const trackAsnWorkflow = useTrackWorkflow(Workflows.ADVANCED_SHIPPING_NOTICE_FLOW);

  const [initialAsn, setInitialAsn] = useAsyncSafeState(null);

  const onClickNewAsn = useCallback(() => {
    const newGuidPlaceholder = GuidService.newGuid();
    trackAsnWorkflow(WorkflowSteps.START);
    setInitialAsn({
      ...initialAdvancedShippingNotice,
      purchaseOrderNumber: newGuidPlaceholder,
    });
    open();
  }, [open, setInitialAsn, trackAsnWorkflow]);

  return (
    <FlexColumn className={styles['panel-content']}>
      <FlexRow className={styles['title-row']}>
        <FlexColumn>
          <Text textType={TextType.H3} value={messages.advancedShippingNoticesTitle} />
          <Text className={styles['grey-637381']} textType={TextType.Paragraph} value={messages.advancedShippingNoticesSubTitle} />
        </FlexColumn>
        <Button className={styles.button} onClick={onClickNewAsn} theme='primary'>
          <FontAwesomeIcon className={styles['button-icon']} icon={faPlus} />
          <FormattedMessage {...messages.createNoticeButtonText} />
        </Button>
      </FlexRow>
      <AdvancedShippingNoticeGridProvider open={open} setInitialAsn={setInitialAsn}>
        <AdvancedShippingNoticeGrid />
        {isOpen && <AdvancedShippingNoticeDrawer closeDrawer={close} initialAsn={initialAsn} trackAsnWorkflow={trackAsnWorkflow} />}
      </AdvancedShippingNoticeGridProvider>
    </FlexColumn>
  );
};
